import Tasting from './Tasting'
export default Tasting
